module.exports = __webpack_public_path__ + "img/splash2.17195136.jpg";